import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Footer from '../../components/footer/Footer';
import { Link } from 'react-router-dom'
import Services from '../../api/service'
// import ServiceTab from './ServiceTab';
import Logo from '../../images/ffsdgroup.png'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const SubmitHandler = (e) => {
    e.preventDefault()
}


const ServiceSinglePage = (props) => {

    const { slug } = useParams()

    const ServiceDetails = Services.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar hclass={'header-style-3'} Logo={Logo} />
            <PageTitle pageTitle={ServiceDetails.sTitle} pagesub={'Services'} />

            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-9 order-lg-2 order-1 col-12">
                            <div className="service-single-content">
                                <div className="service-pic">
                                    <img src={ServiceDetails.sImg} alt="" />
                                </div>
                                <h2>{ServiceDetails.sTitle}</h2>
                                <p>{ServiceDetails.description}</p>
                                <p>{ServiceDetails.des2}</p>
                                <p>{ServiceDetails.des3}</p>
                                <p>{ServiceDetails.des4}</p>
                                <p>{ServiceDetails.des5}</p>
                                <p>{ServiceDetails.des6}</p>
                            </div>
                        </div>
                        <div className="col col-lg-3 order-lg-1 order-2 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <ul>
                                        <li className="current"><Link to="/services">All Service</Link></li>
                                        {Services.map((service, srv) => (
                                            <li className='current' key={srv}><Link onClick={ClickHandler} to={`/service/${service.slug}`}>{service.sTitle}</Link></li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="widget download-widget">
                                    <ul>
                                        <li>
                                        <a href={ServiceDetails.website} target="_blank" rel="noopener noreferrer"><i className="ti-file"></i>Visit Website</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Need help?</h4>
                                        <p>We would be glad to profer Tailored solutions to you. Available 24/7 to attend to your needs</p>
                                        <p>Phone: {ServiceDetails.phone}</p>
                                        {/* <Link onClick={ClickHandler} to='/contact'>Contact With Us</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;
